import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28.8",
  height: "18",
  version: "1.2",
  viewBox: "0 0.1 14.001 9.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.71 1.63q-.06-.22-.18-.42-.11-.2-.28-.36-.16-.17-.36-.28-.2-.12-.42-.18C11.38.1 7 .1 7 .1S2.62.1 1.53.4q-.22.05-.42.17-.2.11-.36.28-.17.16-.28.36-.12.2-.18.42-.07.42-.13.84-.05.42-.09.84t-.06.84Q0 4.58 0 5t.01.85q.02.42.06.84t.09.84q.06.42.14.84.05.22.17.42.11.2.28.36.16.17.36.28.2.12.42.18C2.62 9.9 7 9.9 7 9.9s4.38 0 5.47-.29q.22-.06.42-.18.2-.11.36-.28.17-.16.28-.36.12-.2.17-.42.08-.42.14-.84.05-.42.09-.84t.06-.84Q14 5.42 14 5t-.01-.85q-.02-.42-.06-.84t-.09-.84q-.06-.42-.14-.84zM5.61 7.1V2.9L9.24 5z"
    }, null, -1)
  ]))]))
}
export default { render: render }